import { defineMessages } from 'react-intl';

export default defineMessages({
  'home_page_link_label': {
    'id': 'nav.home_page_link_label',
    'defaultMessage': 'Home Page',
    'description': 'Main navigation home page link text'
  },
  'greeting_label': {
    'id': 'nav.greeting_label',
    'defaultMessage': 'Hi, {name}',
    'description': 'User navigation dropdown greeting text'
  },
  'account_profiles_link_label': {
    'id': 'nav.account_profiles_link_label',
    'defaultMessage': 'Account & Rider Profiles',
    'description': 'User navigation dropdown account & rider profiles link text'
  },
  'logout_link_label': {
    'id': 'nav.logout_link_label',
    'defaultMessage': 'Logout',
    'description': 'User navigation dropdown logout link text'
  }
});



// WEBPACK FOOTER //
// ./src/client/components/nav/messages.js